import { useEffect, useMemo, useState } from "react";
import { useIsInBuilder } from "../../react";
import deepEqual from "../../utils/deepEqual";
import { useMakeswiftHostApiClient } from "../../runtimes/react/host-api-client";
import { useSyncExternalStore } from "use-sync-external-store/shim";
const SnippetLocation = {
  Body: "BODY",
  Head: "HEAD"
};
const filterUsedSnippetProperties = ({
  code,
  builderEnabled,
  liveEnabled,
  location,
  cleanup
}) => ({
  code,
  builderEnabled,
  liveEnabled,
  location,
  cleanup
});
function usePageSnippets({ page }) {
  const isInBuilder = useIsInBuilder();
  const [snippets, setSnippets] = useState(page.snippets);
  const cachedPage = useCachedPage(isInBuilder ? page.id : null);
  useEffect(() => {
    if (cachedPage == null)
      return;
    const oldSnippets = snippets.map(filterUsedSnippetProperties);
    const newSnippets = cachedPage.snippets.map(filterUsedSnippetProperties);
    if (deepEqual(newSnippets, oldSnippets))
      return;
    setSnippets(cachedPage.snippets);
  }, [cachedPage]);
  const filteredSnippets = useMemo(
    () => snippets.filter((snippet) => isInBuilder ? snippet.builderEnabled : snippet.liveEnabled),
    [snippets, isInBuilder]
  );
  const headSnippets = useMemo(
    () => filteredSnippets.filter((snippet) => snippet.location === SnippetLocation.Head),
    [filteredSnippets]
  );
  const bodySnippets = useMemo(
    () => filteredSnippets.filter((snippet) => snippet.location === SnippetLocation.Body),
    [filteredSnippets]
  );
  return { headSnippets, bodySnippets };
}
function useCachedPage(pageId) {
  const client = useMakeswiftHostApiClient();
  const getSnapshot = () => pageId == null ? null : client.readPage(pageId);
  const page = useSyncExternalStore(client.subscribe, getSnapshot, getSnapshot);
  return page;
}
export {
  usePageSnippets
};
//# sourceMappingURL=usePageSnippets.js.map